import { render } from "./HeaderDropdownProfile.vue?vue&type=template&id=65d341f8&ts=true"
import script from "./HeaderDropdownProfile.vue?vue&type=script&lang=ts"
export * from "./HeaderDropdownProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__